import React from 'react';

import { DataPipelineNavItem } from '~/backup/shared/components/DataPipelineNavItem';
import { useFeatureFlags } from '~/contexts/FeatureFlagProvider';
import { Icon } from '~/packages/common-frontend/components/icons';
import {
  GlobalNav,
  GlobalNavRouterLinkItem,
} from '~/packages/common-frontend/layout';

export const BackupOriginatorGlobalNav = ({
  isFixed = true,
}: {
  isFixed?: boolean;
}): React.ReactElement => {
  const flags = useFeatureFlags();
  return (
    <GlobalNav isFixed={isFixed} offsetHeaderCount={1}>
      <DataPipelineNavItem />
      {flags.productsBackupAssistantPermissions === 'allow' && (
        <GlobalNavRouterLinkItem
          to="/agent"
          label="Assistant"
          icon={<Icon icon="robot" />}
        />
      )}
    </GlobalNav>
  );
};
